import "./social-media-creatives.css";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function SocialMediaCreatives() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className="social-media-creatives">
      <div className="social-media-header">
        <h1 className="social-media-header-heading animate__animated animate__fadeIn animate__slow" style={{ textTransform: "uppercase" }}>
          We create high performing creatives for your brand.
        </h1>
        <p className="social-media-header-desc animate__animated animate__fadeIn animate__slow">
          <span className="bold">In</span> a media-flooded world, it is more important than ever to stand out from the crowd. Impress your customers with outstanding visuals, engaging content and precise targeting. We are here - let's unlock your full potential.
        </p>
        <img
          src="/assets/images/social-media-1.webp"
          alt="Social Media Creatives Main Img"
        />
      </div>

      <div className="social-media-list">
        <div className="social-media">
          <img
            className={`social-media-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/social-media-2.webp"
            alt="Service Img"
          />

          <div className="social-media-desc">
            <h2>Social Ad Creatives</h2>
            <p>
              It’s all about picking up new stuff and always asking questions about what you know.
              <br />
              <br />
              We’re on a mission to create awesome ads for your brand. By diving into the data and tweaking our assets, we can whip up some winning creatives for you.
            </p>
            <img
              className={`social-media-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/social-media-2.webp"
              alt="Service Img"
            />
            <div className="social-media-desc-details">
              <h5>&#x2022; Stunning Images</h5>
              <h5>&#x2022; Engaging Videos</h5>
              <h5>&#x2022; Leveraging UGC</h5>
              <h5>&#x2022; Motion Design and Animations</h5>
            </div>
          </div>
        </div>

        <div className="social-media" id="design">
          <div className="social-media-desc">
            <h2>Social Media Content</h2>
            <p>
              Why do you care about how you look or what people think of you? It’s all about wanting to be seen in a certain light, right? The same goes for your brand!
              <br />
              <br />
              We’re here to help your brand shine and create a unique vibe that sticks with people.
            </p>
            <img
              className={`social-media-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/social-media-3.webp"
              alt="Service Img"
            />
            <div className="social-media-desc-details">
              <h5>&#x2022; Targeted Content</h5>
              <h5>&#x2022; Branded Images and Videos</h5>
              <h5>&#x2022; Cross-Platform Publishing</h5>
              <h5>&#x2022; Analysis and Optimization</h5>
            </div>
          </div>

          <img
            className={`social-media-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/social-media-3.webp"
            alt="Service Img"
          />
        </div>

        <div className="social-media" id="development">
          <img
            className={`social-media-img ${window.innerWidth <= 768 ? "d-none" : ""
              }`}
            src="/assets/images/social-media-4.webp"
            alt="Service Img"
          />

          <div className="social-media-desc">
            <h2>Storytelling Commercials</h2>
            <p>
              Hey, remember that one commercial from when you were a kid that just stuck with you? Stories really hit home, right? They make us feel things that linger long after.
              <br />
              <br />
              Want to share your own story? We’re here to help you write it! Let’s turn your story into something unforgettable.
            </p>
            <img
              className={`social-media-img ${window.innerWidth > 768 ? "d-none" : ""
                }`}
              src="/assets/images/social-media-4.webp"
              alt="Service Img"
            />
            <div className="social-media-desc-details">
              <h5>&#x2022; Corporate Videos</h5>
              <h5>&#x2022; Product Commercials</h5>
              <h5>&#x2022; Explanatory</h5>
              <h5>&#x2022; Testimonials</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SocialMediaCreatives;
